<template>
  <div class="r-logo" :style="getStyle()"></div>
</template>

<script>
export default {
  props: {
    size: { type: Number }
  },
  methods: {
    getStyle() {
      return this.size ? { width: `${this.size}px` } : {};
    }
  }
};
</script>

<style lang="scss">
.r-logo {
  background-image: url("../../assets/images/logo/ritm_logo.svg");
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: 50%;
  height: 100%;
  max-height: 100%;
  width: auto;
  margin: 0 auto;
}
</style>
